import React, { useEffect, useState } from 'react';
import CAppTitle from '../../../app/components/CAppTitle';

import { useTranslation } from 'react-i18next';

import useDocumentFiles from '../hooks/useDocumentFiles';
import _ from 'lodash';
import { Button, Grid } from '@mui/material';

import CAppSubTitle from '../../../app/components/CAppSubTitle';

import { Helmet } from 'react-helmet';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import langDocumentFiles from '../langs/langDocumentFiles';
import CInvestDisclaimer from '../../investor/components/CInvestDisclaimer';
import IDocumentFile from '../interfaces/IDocumentFile';
import AppCustomIcon from '../../../app/features/icon/AppIcon';
import FDocumentSearchAutocompleteByName from '../features/search-autocomplete-by-name/FDocumentSearchAutocompleteByName';
import VDocumentFilesTable from '../views/VDocumentFilesTable';
import VDocumentFilesDashboardExpertises from '../views/VDocumentFilesDashboardExpertises';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import DocumentRoutes from '../DocumentRoutes';
import { useNavigate } from 'react-router-dom';

const PDocumentDashboard = () => {
	const { t } = useTranslation();

	const authContext = useAuthContext();

	const { documents } = useDocumentFiles();
	const navigate = useNavigate();

	const [documentLast10Recents, setDocumentLast10Recents] = useState<IDocumentFile[] | null>(null);
	useEffect(() => {
		if (documents) {
			setDocumentLast10Recents(_.orderBy(documents, ['date'], ['desc']).slice(0, 10));
		}
	}, [documents]);

	return (
		<>
			<Helmet>
				<title>
					{authContext.authContext === 'employee' ? '[E] ' : ''} {t(langDocumentFiles.title.tag)} -{' '}
					{authContext.currentCompany ? authContext.currentCompany.name : ''}
				</title>
			</Helmet>
			<CAppTitle title={t(langDocumentFiles.title.tag)} />

			<CAppSubTitle title={t(langDocumentFiles.subtitle_search.tag)} icon={<AppCustomIcon tag="search" />} />
			<Grid container spacing={3} alignItems="center">
				<Grid item sm={10} xs={12}>
					<FDocumentSearchAutocompleteByName />
				</Grid>
				<Grid item sm={2} xs={12}>
					<Button
						id="btn-more-filters"
						fullWidth
						color="secondary"
						variant="contained"
						size="small"
						onClick={() => navigate(HAppRoutes.getPath(DocumentRoutes.documents_search.tag))}
					>
						{t(langDocumentFiles.btn_search_with_more_filters.tag)}
					</Button>
				</Grid>
			</Grid>

			<VDocumentFilesDashboardExpertises documentFiles={documents ?? []} />

			<CAppSubTitle
				title={t(langDocumentFiles.subtitle_last_10_documents.tag)}
				icon={<AppCustomIcon tag="folders" />}
			/>
			<VDocumentFilesTable documents={documentLast10Recents ?? []} hideFooter />

			<CInvestDisclaimer />
		</>
	);
};

export default PDocumentDashboard;
